import React from 'react';
import '../../styles/industries.css';
import { motion } from 'framer-motion';
import consumerTechImg from '../../assets/consumer-tech.jpg';

const ConsumerTech = () => (
  <div
    className="industry-page"
    style={{ backgroundImage: `url(${consumerTechImg})` }}
  >
    <motion.div
      className="industry-content"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1>Consumer Tech</h1>
      <p>
        We deliver seamless, scalable platforms for digital commerce, lifestyle apps, and customer-first technology experiences.
      </p>
      <ul className="bullet-points">
        <li>🛍️ D2C eCommerce platforms.</li>
        <li>🤝 B2B Digital Solutions & Integrations.</li>
        <li>📱 Mobile-first design & UX.</li>
        <li>🎯 Customer analytics & engagement tools.</li>
        <li>🔒 Payment & loyalty system integrations.</li>
        <li>📊 Intelligent Data Extraction & Processing.</li>
      </ul>
    </motion.div>
  </div>
);

export default ConsumerTech;
